module.exports = __webpack_public_path__ + "static/img/11_4Archive_15i_KaprowletteraboutphotosLoss_2.f79113d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow/archive/11_4Archive_15i_KaprowletteraboutphotosLoss_2.jpg
// module id = HSFh
// module chunks = 0